import { render, staticRenderFns } from "./template-header.vue?vue&type=template&id=457d8b1e&scoped=true"
import script from "./template-header.vue?vue&type=script&lang=js"
export * from "./template-header.vue?vue&type=script&lang=js"
import style0 from "./template-header.vue?vue&type=style&index=0&id=457d8b1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457d8b1e",
  null
  
)

export default component.exports